import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ApiProblem } from "./api/client.js";
import { App } from "./app/App.js";
import "./i18n/index.js";
import "./styles.css";
import { HelpProvider } from "./ui/help.js";
import { applyTheme, savedTheme } from "./ui/theme.js";
import { ToastProvider } from "./ui/toast.js";

applyTheme(savedTheme());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Client errors (401, 403, 404, 422) do not get better by retrying.
      retry: (count, error) =>
        count < 2 && !(error instanceof ApiProblem && error.status >= 400 && error.status < 500),
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <HelpProvider>
          <App />
        </HelpProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
